import '../jquery'

let ready_mass_sms_export;

ready_mass_sms_export = function() {
  let csvExportColSepFieldsDisplay;
  $("body").on("change", "#csv_export_col_sep_fields input[type='radio']", function() {
    let sepType;
    sepType = $("#csv_export_col_sep_fields").find('input:checked').val();
    if (sepType === 'other') {
      $('#csv_export_col_sep').prop('readonly', false);
      return $('#csv_export_col_sep').val('');
    } else {
      $('#csv_export_col_sep').prop('readonly', true);
      return $('#csv_export_col_sep').val(sepType);
    }
  });
  $("body").on("change", "#export_file_type", function() {
    let fileType;
    fileType = $(this).val();
    return csvExportColSepFieldsDisplay(fileType);
  });
  return csvExportColSepFieldsDisplay = function(extension) {
    if (extension === 'csv') {
      return $('#csv_export_col_sep_fields').show();
    } else {
      $('#csv_export_col_sep_fields').hide();
      $('#csv_export_col_sep').val('');
      return $('#csv_export_col_sep_fields').find('input:checked').prop('checked', false);
    }
  };
};

$(document).ready(ready_mass_sms_export);

$(document).on('turbo:load', ready_mass_sms_export);